import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = (props) => {
    const location = useLocation();
    useEffect(() => {
        window.scrollBy(0, 0);
        // window.scrollX
    }, [location]);

    return <>{props.children}</>;
};

export default ScrollToTop;
